/**
 * Custom functionality for Contact page.
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const form = require('../components/form-block');

exports.init = function () {
    // Run init methods...
    form.init();
};